var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 9C13.2283 9 13.8999 8.32861 13.8999 7.5C13.8999 6.67139 13.2283 6 12.3999 6C11.5715 6 10.8999 6.67139 10.8999 7.5C10.8999 8.32861 11.5715 9 12.3999 9Z",
    fill: "#1226AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4ZM2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12Z",
    fill: "#1226AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 10C13.3521 10 13.7998 10.4477 13.7998 11V16H14.2998C14.8521 16 15.2998 16.4477 15.2998 17C15.2998 17.5523 14.8521 18 14.2998 18H11.2998C10.7475 18 10.2998 17.5523 10.2998 17C10.2998 16.4477 10.7475 16 11.2998 16H11.7998V11.8H11.4C10.9029 11.8 10.5 11.3971 10.5 10.9C10.5 10.4029 10.9029 10 11.4 10H12.6C12.6329 10 12.6653 10.0018 12.6973 10.0052C12.731 10.0018 12.7652 10 12.7998 10Z",
    fill: "#1226AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleInformation);
export default __webpack_public_path__ + "static/media/icon_circle-information.b372cd40b2ebf94b2a6d86647206ceed.svg";
export { ForwardRef as ReactComponent };